import { faReact } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import MyWorkData from '../../fakeData/MyWorkData';
import MyWorkDetails from '../MyWorkDetails/MyWorkDetails';
import './MyReactWork.css'

const MyReactWork = () => {
   
    return (
        <div className="container">
        <div className="row">
           </div>
           <div className="text-white ">
            <h4 className="mt-3 text-center animate__animated animate__fadeInLeft animate__delay-2s"><h2><FontAwesomeIcon icon={faReact}/>  React Project</h2></h4>
            <hr className="text-white"/>
              { 
               MyWorkData.map(data => <MyWorkDetails data={data} key={data.title}/>)
              }
           </div>
        </div>
    );
};

export default MyReactWork;